import { render, staticRenderFns } from "./VisaApply.vue?vue&type=template&id=5cfc5c30&scoped=true"
import script from "./VisaApply.vue?vue&type=script&lang=js"
export * from "./VisaApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc5c30",
  null
  
)

export default component.exports